module.exports = __webpack_public_path__ + "img/people-blue.913d2806.svg";